import React, { useState } from "react";
import "./DropdownMethodology.css";

function DropdownMethodology({ buttonText, component }) {
  const [showComponent, setShowComponent] = useState(false);

  const handleButtonClick = () => {
    setShowComponent(!showComponent);
  };

  return (
    <div className="page-wrapper">
      <button className="btn" onClick={handleButtonClick}>
        {buttonText}
        {!showComponent ? (
          <i className="fas fa-chevron-down"></i>
        ) : (
          <i className="fas fa-chevron-up"></i>
        )}
      </button>
      {showComponent && <div className="dropdown-component">{component}</div>}
    </div>
  );
}

export default DropdownMethodology;
